export default "__VITE_ASSET__Dd3eLmye__"